var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.selectedRelease
    ? _c(
        "div",
        { staticClass: "layer-list-container" },
        [
          _c(
            "div",
            { staticClass: "data-panel" },
            [
              _c("fa", {
                staticClass: "data-panel__minimize",
                attrs: {
                  icon: ["fas", _vm.isMinimized ? "caret-up" : "caret-down"],
                  title: _vm.isMinimized
                    ? "Expand layer list"
                    : "Minimize layer list",
                },
                on: { click: _vm.toggleMinimize },
              }),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-2", attrs: { "no-gutters": "" } },
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "button",
                      {
                        staticClass: "change-region-btn",
                        attrs: { title: "Change Dataset" },
                        on: {
                          click: function ($event) {
                            return _vm.$bvModal.show("genericReleaseModal")
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "change-region-icon",
                            attrs: {
                              viewBox: "0 0 16 16",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("circle", {
                              attrs: {
                                cx: "8",
                                cy: "8",
                                r: "6.5",
                                stroke: "currentColor",
                                "stroke-width": "1.2",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M8 1.5C8 1.5 10.5 4 10.5 8S8 14.5 8 14.5M8 1.5C8 1.5 5.5 4 5.5 8S8 14.5 8 14.5M1.5 8h13",
                                stroke: "currentColor",
                                "stroke-width": "1.2",
                                "stroke-linecap": "round",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("Change Dataset")]),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.prod
                ? _c(
                    "b-row",
                    [
                      _c("b-col", { staticClass: "layer-list-font" }, [
                        _vm._v("Production"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "layer-list-font" }, [
                    _vm._v(_vm._s(_vm.selectedRelease.extent_description)),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "layer-list-font" }, [
                    _vm._v(_vm._s(_vm.selectedRelease.release_label)),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isMinimized,
                  expression: "!isMinimized",
                },
              ],
              staticClass: "layers scrollable scroll-Container",
            },
            [
              _c(
                "draggable",
                [
                  _c(
                    "transition-group",
                    { attrs: { type: "transition", name: "flip-list" } },
                    _vm._l(_vm.layerButtons, function (element, index) {
                      return _c(
                        "b-row",
                        {
                          key: element.name,
                          staticClass: "layer-row",
                          class: _vm.getLayerClass(index, element),
                          attrs: { id: element.name },
                        },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "layer-btn",
                              class: _vm.getLayerClass(index, element),
                              attrs: { cols: "10" },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleLayer(element, $event)
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "layer-row-label" }, [
                                _vm._v(
                                  _vm._s(_vm.getLayerDisplayName(element))
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "layer-arrow layer-arrow--end",
                              attrs: { cols: "2" },
                            },
                            [
                              _c("fa", {
                                staticClass: "cursor",
                                attrs: {
                                  title: "Move Layer To Top",
                                  icon: ["fas", "long-arrow-alt-up"],
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toTopOfList(
                                      element.display_name
                                        ? element.display_name
                                        : element.name
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              !_vm.selectedRelease.release_label.includes("WCL")
                                ? _c("fa", {
                                    class: [
                                      _vm.filterClasses[index],
                                      {
                                        "disabled-icon":
                                          _vm.isLayerFilterDisabled,
                                      },
                                    ],
                                    attrs: {
                                      disabled: _vm.isLayerFilterDisabled,
                                      id: `icon${index}`,
                                      title: "Layer Filter",
                                      icon: ["fas", "filter"],
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.initFilterModal(
                                          element.name,
                                          `icon${index}`
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("Generic_LayerFilterModal", {
            attrs: {
              layerProperties: _vm.layerProperties,
              filter_layer: _vm.filter_layer,
              mmp_layersObj: _vm.mmp_layersObj,
              zoomLevelCap: _vm.zoomLevelCap,
              generateCQLObj: _vm.generateCQLObj,
              map: _vm.map,
              selectedElement: _vm.selectedElement,
            },
            on: {
              filterClassesObjChanged: function ($event) {
                return _vm.$emit("filterClassesObjChanged", $event)
              },
              rulesChanged: function ($event) {
                _vm.rules = $event
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }